import React from "react";
import ReactDOM from "react-dom/client";
import LoginRouter from "./LoginRouter";
import { BrowserRouter } from "react-router-dom";
import { store, persistor } from "./reducer/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LoginRouter />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
